{
  "v5.m1.annuler": "Cancel",
  "v5.m1.branches.par_defaut": "default",
  "v5.m1.branches.titre": "Branches",
  "v5.m1.branches.vide": "No branch in the repository.",
  "v5.m1.branches.voir_pipelines": "Pipelines of {{branche}}",
  "v5.m1.cas.afficher_test": "Show the executable test",
  "v5.m1.cas.ajoute": "Case added to the suite.",
  "v5.m1.cas.ajouter_suite": "Add to the regression suite",
  "v5.m1.cas.attendu": "expected: {{attendu}}",
  "v5.m1.cas.aucune_campagne": "No open campaign in this project.",
  "v5.m1.cas.campagne": "Execution campaign",
  "v5.m1.cas.campagne_option": "{{nom}} (#{{id}})",
  "v5.m1.cas.campagne_requise": "Choose an open campaign to run this case.",
  "v5.m1.cas.campagnes": "Open campaigns",
  "v5.m1.cas.choisir_campagne": "Choose a campaign",
  "v5.m1.cas.cibles": "Proven targets",
  "v5.m1.cas.contenu_non_fige": "The case content is not frozen on publishing: only the version and position are.",
  "v5.m1.cas.criticite": "Criticality",
  "v5.m1.cas.declarer_anomalie": "Report a defect from this result",
  "v5.m1.cas.deja_inclus": "This case is already in the regression suite.",
  "v5.m1.cas.echec_ajout": "The case was not added.",
  "v5.m1.cas.ecrire_test": "Write the test",
  "v5.m1.cas.etat_test.a_valider": "To validate",
  "v5.m1.cas.etat_test.absent": "Missing",
  "v5.m1.cas.etat_test.valide": "Validated",
  "v5.m1.cas.executer": "Run this case",
  "v5.m1.cas.executer_campagne": "Run in the campaign",
  "v5.m1.cas.historique": "History",
  "v5.m1.cas.identite": "Identity",
  "v5.m1.cas.introuvable": "Test case not found in this project.",
  "v5.m1.cas.libelle": "Test case",
  "v5.m1.cas.masquer_test": "Hide the executable test",
  "v5.m1.cas.modifier_identite": "Edit identity",
  "v5.m1.cas.modifier_scenario": "Edit the scenario",
  "v5.m1.cas.niveau.critical": "Critical",
  "v5.m1.cas.niveau.high": "High",
  "v5.m1.cas.niveau.low": "Low",
  "v5.m1.cas.niveau.medium": "Medium",
  "v5.m1.cas.nom": "Name",
  "v5.m1.cas.origine.element_du_cas": "case item",
  "v5.m1.cas.origine.trace_declaree": "declared trace",
  "v5.m1.cas.origine_execution": "Source execution",
  "v5.m1.cas.preparer_validation": "Prepare the validation",
  "v5.m1.cas.priorite": "Priority",
  "v5.m1.cas.reference": "Reference",
  "v5.m1.cas.resultat": "Execution result #{{id}}",
  "v5.m1.cas.resultat_attendu": "Expected result",
  "v5.m1.cas.retirer_suite": "Remove from the suite",
  "v5.m1.cas.retour_tests": "Back to tests",
  "v5.m1.cas.sans_cible": "No proven target.",
  "v5.m1.cas.sans_etape": "No step.",
  "v5.m1.cas.sans_execution_origine": "No source execution: open this case from a result to report a defect.",
  "v5.m1.cas.sans_version": "No published version contains this case.",
  "v5.m1.cas.scenario": "Scenario",
  "v5.m1.cas.suite": "Regression suite",
  "v5.m1.cas.test_absent": "No executable test.",
  "v5.m1.cas.test_executable": "Executable test",
  "v5.m1.cas.titre": "Test case",
  "v5.m1.cas.version": "Plan {{plan}} · version {{version}} · published by {{auteur}}",
  "v5.m1.cas.voir_anomalie": "View the defect",
  "v5.m1.code.ATTESTATION_RELECTURE_REQUISE": "Confirm you reviewed the test before validating it.",
  "v5.m1.code.CONTEXTE_INCOMPLET": "The context of this action is incomplete.",
  "v5.m1.code.DROIT_NON_TENU": "You do not hold the right required for this action.",
  "v5.m1.code.GARDE_DROIT_ABSENTE": "This action is not yet open on the gateway.",
  "v5.m1.code.RESOURCE_UNAVAILABLE": "Job not found in this project.",
  "v5.m1.code.RETOUR_INTROUVABLE": "This feedback was not found in this project.",
  "v5.m1.code.REVISION_NOT_DONE": "This revision is not finished: it cannot be published.",
  "v5.m1.code.REVISION_NOT_FOUND": "Revision not found in this project.",
  "v5.m1.code.SANS_SESSION": "Your session has expired: sign in again.",
  "v5.m1.code.SCM_NOT_CONFIGURED": "No repository is connected to this project.",
  "v5.m1.code.SCM_NOT_FOUND": "Object not found in the connected repository.",
  "v5.m1.code.TEST_CODE_VALIDATOR_NOT_INDEPENDENT": "The test must be validated by someone other than its author.",
  "v5.m1.code.VALIDATION_ERROR": "The request is incomplete or invalid.",
  "v5.m1.code.VALIDATION_PAR_UN_TIERS": "This action must be done by someone other than the author.",
  "v5.m1.code.WAIVER_ALREADY_ACTIVE": "A waiver is already active for this vulnerability.",
  "v5.m1.code.WAIVER_EXPIRY_REQUIRED": "The waiver expiry date is required.",
  "v5.m1.code.WAIVER_SELF_APPROVAL_REFUSED": "The waiver must be approved by someone other than its requester.",
  "v5.m1.code.ecart.VALIDATION_ERROR": "Waiver request rejected: {{message}}",
  "v5.m1.code.ecart.VALIDATION_PAR_UN_TIERS": "The waiver must be approved by someone other than its requester.",
  "v5.m1.code.ecart.WAIVER_EXPIRY_REQUIRED": "The expiry date must be in the future.",
  "v5.m1.code.ecart.WAIVER_PIPELINE_VALIDITY_EXCEEDED": "A waiver on the pipeline control lasts {{max_days}} days at most: the latest acceptable expiry date is {{latest_date}}.",
  "v5.m1.code.ecart.WAIVER_SECURITY_REVIEW_REQUIRED": "Beyond 90 days, a security waiver requires a recorded security review: choose an earlier expiry date.",
  "v5.m1.code.publier.VALIDATION_PAR_UN_TIERS": "The revision must be reviewed by someone other than the publisher.",
  "v5.m1.code.test.VALIDATION_PAR_UN_TIERS": "The test must be validated by someone other than its author.",
  "v5.m1.declencher.branche": "Branch",
  "v5.m1.declencher.branche_requise": "Choose a branch.",
  "v5.m1.declencher.branches": "Repository branches",
  "v5.m1.declencher.choisir_branche": "Choose a branch",
  "v5.m1.declencher.consommation": "The pipeline consumes repository runner time.",
  "v5.m1.declencher.declenche": "Pipeline triggered.",
  "v5.m1.declencher.declencher": "Trigger",
  "v5.m1.declencher.echec": "Triggering failed.",
  "v5.m1.declencher.effet": "A pipeline will run on branch “{{branche}}” of repository {{depot}} ({{url}}).",
  "v5.m1.declencher.effet_sans_branche": "Choose the branch to run the pipeline on.",
  "v5.m1.declencher.raison_depot": "Connect a repository to the project to trigger a pipeline.",
  "v5.m1.declencher.source": "Source kept: application {{application}}, revision {{revision}}.",
  "v5.m1.declencher.titre": "Trigger a repository pipeline",
  "v5.m1.depot.connecte": "Repository connected: project {{depot}} on {{url}}.",
  "v5.m1.depot.connexion": "Repository connection",
  "v5.m1.depot.echec_test": "The connection test failed.",
  "v5.m1.depot.non_connecte": "No repository is connected to this project.",
  "v5.m1.depot.reglages": "Repository settings",
  "v5.m1.depot.teste": "Connection verified: {{chemin}}.",
  "v5.m1.depot.tester": "Test the connection",
  "v5.m1.depot.titre": "Project repository",
  "v5.m1.ecarter.composant": "Component",
  "v5.m1.ecarter.contexte_requis": "Open this dialog from a pipeline vulnerability.",
  "v5.m1.ecarter.echeance": "Expiry",
  "v5.m1.ecarter.echeance_aide": "{{jours}} days at most (pipeline control): until {{date}} inclusive.",
  "v5.m1.ecarter.echeance_borne": "The expiry date must be between tomorrow and {{date}}.",
  "v5.m1.ecarter.echeance_requise": "The expiry date is required.",
  "v5.m1.ecarter.echec": "The waiver was not submitted.",
  "v5.m1.ecarter.gravite": "Severity",
  "v5.m1.ecarter.identifiant": "Identifier",
  "v5.m1.ecarter.justification": "Justification",
  "v5.m1.ecarter.motif_requis": "The reason is required.",
  "v5.m1.ecarter.nature": "Reason type",
  "v5.m1.ecarter.nature.non_affecte_justifie": "Not affected, justified",
  "v5.m1.ecarter.nature.risque_accepte": "Risk accepted",
  "v5.m1.ecarter.soumettre": "Submit the waiver",
  "v5.m1.ecarter.soumis": "Waiver submitted.",
  "v5.m1.ecarter.soumission_impossible_inconnue": "Cannot submit: the vulnerability is not reported by this pipeline’s analysis.",
  "v5.m1.ecarter.tiers": "The waiver takes effect only after another person approves it.",
  "v5.m1.ecarter.titre": "Waive a vulnerability with a reason",
  "v5.m1.ecarter.vulnerabilite": "Vulnerability",
  "v5.m1.ecarter.vulnerabilite_inconnue": "This vulnerability is not reported in the pipeline.",
  "v5.m1.ecran_non_realise": "“{{ecran}}”: this screen comes with another batch of the release; it is not open yet.",
  "v5.m1.etat.chargement": "Loading: {{quoi}}…",
  "v5.m1.etat.en_cours": "In progress…",
  "v5.m1.etat.erreur": "{{quoi}}: reading failed.",
  "v5.m1.etat.introuvable": "{{quoi}} not found in this project.",
  "v5.m1.etat.reessayer": "Retry",
  "v5.m1.etat.refus": "{{quoi}}: access denied.",
  "v5.m1.execution.aucun_resultat": "No step result recorded.",
  "v5.m1.execution.choisir_etape": "Choose a step to see its result.",
  "v5.m1.execution.code": "Exit code: {{code}}",
  "v5.m1.execution.debut": "Start",
  "v5.m1.execution.duree": "Duration: {{duree}} s",
  "v5.m1.execution.duree_inconnue": "Unknown duration",
  "v5.m1.execution.etape.echoue": "Failure",
  "v5.m1.execution.etape.non_execute": "Not run",
  "v5.m1.execution.etape.reussi": "Passed",
  "v5.m1.execution.etat": "State",
  "v5.m1.execution.etat.echoue": "Failed",
  "v5.m1.execution.etat.en_attente": "Pending",
  "v5.m1.execution.etat.non_execute": "Not run",
  "v5.m1.execution.etat.termine": "Finished",
  "v5.m1.execution.fin": "End",
  "v5.m1.execution.introuvable": "Execution not found.",
  "v5.m1.execution.lanceur": "Started by",
  "v5.m1.execution.libelle": "Execution",
  "v5.m1.execution.numero": "Execution #{{id}}",
  "v5.m1.execution.par_etape": "Result per step",
  "v5.m1.execution.resultat": "Result of {{etape}}",
  "v5.m1.execution.sortie_absente": "No output kept for this step.",
  "v5.m1.execution.titre": "Command suite execution",
  "v5.m1.execution.voir": "View the result of {{etape}}",
  "v5.m1.execution.voir_suite": "View the command suite",
  "v5.m1.fermer": "Close",
  "v5.m1.fiche_pub.aucun_environnement": "No environment linked to the application repository.",
  "v5.m1.fiche_pub.choisir_environnement": "Choose an environment",
  "v5.m1.fiche_pub.commit": "Commit",
  "v5.m1.fiche_pub.date": "Date",
  "v5.m1.fiche_pub.demandee_par": "Requested by",
  "v5.m1.fiche_pub.dernier_refus": "Last refusal: {{message}}",
  "v5.m1.fiche_pub.echec_relier": "Linking failed.",
  "v5.m1.fiche_pub.effet_raccordement": "Revision {{revision}} will be linked to environment {{environnement}}; the service may be affected.",
  "v5.m1.fiche_pub.effet_sans_environnement": "Choose an environment: linking requires the deploy right.",
  "v5.m1.fiche_pub.environnement": "Environment",
  "v5.m1.fiche_pub.environnement_non_identifie": "No environment chosen.",
  "v5.m1.fiche_pub.environnements": "Environments",
  "v5.m1.fiche_pub.erreur": "Error",
  "v5.m1.fiche_pub.etat": "State",
  "v5.m1.fiche_pub.libelle": "Publication",
  "v5.m1.fiche_pub.pipeline": "Pipeline #{{id}}",
  "v5.m1.fiche_pub.publication": "Publication",
  "v5.m1.fiche_pub.raccordement": "Environment link",
  "v5.m1.fiche_pub.relais": "Find a release manager",
  "v5.m1.fiche_pub.relancee": "Publication retried.",
  "v5.m1.fiche_pub.relancer": "Retry the publication",
  "v5.m1.fiche_pub.relancer_consequence": "The same revision is published again on the same record.",
  "v5.m1.fiche_pub.relancer_titre": "Retry publishing {{revision}}?",
  "v5.m1.fiche_pub.relancer_verbe": "Retry",
  "v5.m1.fiche_pub.relie": "Environment linked.",
  "v5.m1.fiche_pub.relier": "Link the environment",
  "v5.m1.fiche_pub.relier_consequence": "The environment will use the application repository as its source.",
  "v5.m1.fiche_pub.relier_titre": "Link environment {{environnement}}?",
  "v5.m1.fiche_pub.relier_verbe": "Link",
  "v5.m1.fiche_pub.sans_pipeline": "No pipeline identified.",
  "v5.m1.fiche_pub.titre": "Code publication detail",
  "v5.m1.fiche_pub.voir_environnement": "View environment {{nom}}",
  "v5.m1.fusion.branche_cible": "Target branch",
  "v5.m1.fusion.branche_par_defaut": "Repository default branch",
  "v5.m1.fusion.branche_source": "Source branch",
  "v5.m1.fusion.construit_serveur": "Built by the server from the item",
  "v5.m1.fusion.creation": "The request is built by the server from a project item.",
  "v5.m1.fusion.creee": "Merge request created.",
  "v5.m1.fusion.creer": "Create the merge request",
  "v5.m1.fusion.echec": "The merge request was not created.",
  "v5.m1.fusion.element": "Item #{{id}}",
  "v5.m1.fusion.element_requis": "Enter the project item to propose.",
  "v5.m1.fusion.etat.fermee": "Closed",
  "v5.m1.fusion.etat.fusionnee": "Merged",
  "v5.m1.fusion.etat.ouverte": "Open",
  "v5.m1.fusion.libelle": "Merge request",
  "v5.m1.fusion.provenance": "Provenance",
  "v5.m1.fusion.provenance_observee": "Branch {{branche}}, commit {{commit}}",
  "v5.m1.fusion.sans_provenance": "No provenance observed.",
  "v5.m1.fusion.selecteur": "Project item (number)",
  "v5.m1.fusion.titre": "Branch and merge request",
  "v5.m1.fusion.titre_creation": "Propose a merge",
  "v5.m1.fusion.titre_description": "Title and description",
  "v5.m1.fusions.etat_gitlab.closed": "Closed",
  "v5.m1.fusions.etat_gitlab.locked": "Locked",
  "v5.m1.fusions.etat_gitlab.merged": "Merged",
  "v5.m1.fusions.etat_gitlab.opened": "Open",
  "v5.m1.fusions.lien": "!{{iid}} {{titre}}",
  "v5.m1.fusions.proposer": "Propose a merge",
  "v5.m1.fusions.titre": "Merge requests",
  "v5.m1.fusions.vide": "No merge request.",
  "v5.m1.gitlab.statut.canceled": "Canceled",
  "v5.m1.gitlab.statut.created": "Created",
  "v5.m1.gitlab.statut.failed": "Failed",
  "v5.m1.gitlab.statut.manual": "Manual",
  "v5.m1.gitlab.statut.pending": "Pending",
  "v5.m1.gitlab.statut.running": "Running",
  "v5.m1.gitlab.statut.skipped": "Skipped",
  "v5.m1.gitlab.statut.success": "Success",
  "v5.m1.journal.aucun_resultat": "No result.",
  "v5.m1.journal.cible": "Mission {{mission}} · task {{tache}} · step {{etape}}",
  "v5.m1.journal.cible_absente": "Target not provided by the job",
  "v5.m1.journal.cible_libelle": "Job target",
  "v5.m1.journal.col.date": "Date",
  "v5.m1.journal.col.document": "Document",
  "v5.m1.journal.col.statut": "Status",
  "v5.m1.journal.col.traitement": "Job",
  "v5.m1.journal.deposer": "Submit an input",
  "v5.m1.journal.detail": "Detail",
  "v5.m1.journal.etape_ciblee": "Open the targeted step",
  "v5.m1.journal.etape_indisponible": "The mission, task and step of this job are not all known.",
  "v5.m1.journal.executant": "Worker",
  "v5.m1.journal.executant_disponible": "Worker available",
  "v5.m1.journal.executant_indisponible": "Worker unavailable: {{raison}}",
  "v5.m1.journal.filtre_recu": "Filtered on: {{cible}}",
  "v5.m1.journal.liste": "Project jobs",
  "v5.m1.journal.masquer_detail": "Hide detail",
  "v5.m1.journal.ordre": "Order",
  "v5.m1.journal.ordre.croissant": "Ascending",
  "v5.m1.journal.ordre.decroissant": "Descending",
  "v5.m1.journal.ouvrir_traitement": "Open job {{id}}",
  "v5.m1.journal.rechercher": "Search",
  "v5.m1.journal.resultats_semantiques": "Semantic search results",
  "v5.m1.journal.semantique": "Semantic search",
  "v5.m1.journal.statut.done": "Done",
  "v5.m1.journal.statut.failed": "Failed",
  "v5.m1.journal.statut.pending": "Pending",
  "v5.m1.journal.statut.processing": "Processing",
  "v5.m1.journal.statut.worker_lost": "Worker lost",
  "v5.m1.journal.terme_requis": "Type a term to run the semantic search.",
  "v5.m1.journal.titre": "Job log",
  "v5.m1.journal.tous": "All jobs",
  "v5.m1.journal.tous_affiches": "All project jobs are shown.",
  "v5.m1.journal.trier_par": "Sort by",
  "v5.m1.journal.vide": "No job in this project.",
  "v5.m1.journal.voir_detail": "Show detail",
  "v5.m1.missions.arret_ia": "AI stop",
  "v5.m1.missions.attentes": "Human decisions pending",
  "v5.m1.missions.attentes_vide": "No human decision pending.",
  "v5.m1.missions.aucun_resultat": "No mission for this filter.",
  "v5.m1.missions.col.avancement": "Progress",
  "v5.m1.missions.col.date": "Created",
  "v5.m1.missions.col.etat": "State",
  "v5.m1.missions.col.mission": "Mission",
  "v5.m1.missions.escalades": "{{n}} open escalation(s)",
  "v5.m1.missions.filtre.a_decider": "To decide",
  "v5.m1.missions.filtre.arretees": "Stopped",
  "v5.m1.missions.filtre.echouees": "Failed",
  "v5.m1.missions.filtre.en_cours": "In progress",
  "v5.m1.missions.filtre.reussies": "Succeeded",
  "v5.m1.missions.filtre.suspendues": "Suspended",
  "v5.m1.missions.filtre.toutes": "All",
  "v5.m1.missions.filtre_etat": "State",
  "v5.m1.missions.ia_active": "AI is available.",
  "v5.m1.missions.ia_interrompue": "AI is stopped: no mission progresses.",
  "v5.m1.missions.lancer": "Launch a mission",
  "v5.m1.missions.liste": "Project missions",
  "v5.m1.missions.plan_a_approuver": "Plan to approve",
  "v5.m1.missions.retour_projet": "Back to project",
  "v5.m1.missions.statut.draft": "Draft",
  "v5.m1.missions.statut.failed": "Failed",
  "v5.m1.missions.statut.plan_approved": "Plan approved",
  "v5.m1.missions.statut.plan_proposed": "Plan proposed",
  "v5.m1.missions.statut.running": "Running",
  "v5.m1.missions.statut.stopped": "Stopped",
  "v5.m1.missions.statut.succeeded": "Succeeded",
  "v5.m1.missions.statut.suspended": "Suspended",
  "v5.m1.missions.supervision": "Agent supervision",
  "v5.m1.missions.taches": "{{fait}} / {{total}} tasks",
  "v5.m1.missions.titre": "Missions",
  "v5.m1.missions.tri": "Sort",
  "v5.m1.missions.tri.plus_anciens": "Oldest first",
  "v5.m1.missions.tri.plus_recents": "Newest first",
  "v5.m1.missions.vide": "No mission in this project.",
  "v5.m1.partage.actif": "Active link",
  "v5.m1.partage.adresse": "Address",
  "v5.m1.partage.apercu_arrete": "Preview stopped",
  "v5.m1.partage.auteur": "Created by",
  "v5.m1.partage.copie": "Link copied.",
  "v5.m1.partage.copie_impossible": "Copy failed: select the address shown.",
  "v5.m1.partage.copier": "Copy the link",
  "v5.m1.partage.echeance": "Expires",
  "v5.m1.partage.echec_revoquer": "Revoking failed.",
  "v5.m1.partage.etat": "State",
  "v5.m1.partage.hors_contexte": "This link does not belong to this preview of this project.",
  "v5.m1.partage.introuvable": "Share link not found.",
  "v5.m1.partage.libelle": "Share link",
  "v5.m1.partage.lien_de": "Preview of {{application}}, revision {{revision}}",
  "v5.m1.partage.ouvrir_apercu": "Open the preview",
  "v5.m1.partage.retour": "Back to previews",
  "v5.m1.partage.revoque": "Link revoked.",
  "v5.m1.partage.revoque_ou_echu": "This link was revoked or has expired.",
  "v5.m1.partage.revoquer": "Revoke the link",
  "v5.m1.partage.revoquer_consequence": "The link stops opening the preview for all its recipients.",
  "v5.m1.partage.revoquer_titre": "Revoke this share link?",
  "v5.m1.partage.revoquer_verbe": "Revoke",
  "v5.m1.partage.titre": "Preview share link",
  "v5.m1.pipeline.analyse_non_raccordee": "Debt and thresholds: no analysis tool connected; gates read from the pipeline jobs.",
  "v5.m1.pipeline.aucun_traitement": "No job in this pipeline.",
  "v5.m1.pipeline.aucune_porte": "No quality gate in this pipeline.",
  "v5.m1.pipeline.aucune_vulnerabilite": "No vulnerability found.",
  "v5.m1.pipeline.couverture": "New code coverage: {{valeur}} %",
  "v5.m1.pipeline.couverture_inconnue": "New code coverage not measured.",
  "v5.m1.pipeline.ecart_accorde": "Waiver approved",
  "v5.m1.pipeline.ecart_detail": "Reason: {{motif}} · expires {{echeance}} · requested by {{auteur}}",
  "v5.m1.pipeline.ecart_valide": "Waiver approved.",
  "v5.m1.pipeline.ecarter": "Waive {{id}}",
  "v5.m1.pipeline.ecarts": "Waivers",
  "v5.m1.pipeline.echec_valider": "Approving the waiver failed.",
  "v5.m1.pipeline.etat.annule": "Canceled",
  "v5.m1.pipeline.etat.echoue": "Failed",
  "v5.m1.pipeline.etat.en_attente": "Pending",
  "v5.m1.pipeline.etat.en_cours": "Running",
  "v5.m1.pipeline.etat.reussi": "Succeeded",
  "v5.m1.pipeline.introuvable": "Pipeline not found.",
  "v5.m1.pipeline.libelle": "Pipeline",
  "v5.m1.pipeline.lien": "Pipeline #{{id}} ({{ref}})",
  "v5.m1.pipeline.porte.echouee": "Failed",
  "v5.m1.pipeline.porte.en_cours": "Running",
  "v5.m1.pipeline.porte.non_jouee": "Not run",
  "v5.m1.pipeline.porte.passee": "Passed",
  "v5.m1.pipeline.portes": "Code quality gates",
  "v5.m1.pipeline.relecture_attente": "Review pending",
  "v5.m1.pipeline.titre": "Repository pipeline detail",
  "v5.m1.pipeline.trace": "Job trace",
  "v5.m1.pipeline.trace_vide": "Empty trace.",
  "v5.m1.pipeline.valider_ecart": "Approve the waiver",
  "v5.m1.pipeline.verdict.aucune_porte": "No gate",
  "v5.m1.pipeline.verdict.echouee": "Failed",
  "v5.m1.pipeline.verdict.en_cours": "Running",
  "v5.m1.pipeline.verdict.incomplete": "Incomplete",
  "v5.m1.pipeline.verdict.passee": "Passed",
  "v5.m1.pipeline.voir_trace": "View the trace of {{nom}}",
  "v5.m1.pipeline.vulnerabilites": "Revision vulnerabilities",
  "v5.m1.pipelines.declencher_lien": "Trigger a pipeline",
  "v5.m1.pipelines.lien": "Pipeline #{{id}} ({{ref}})",
  "v5.m1.pipelines.liste": "Repository pipelines",
  "v5.m1.pipelines.vide": "No pipeline in the repository.",
  "v5.m1.publication.application": "Application",
  "v5.m1.publication.applications": "Project applications",
  "v5.m1.publication.aucune_application": "No application generated in this project.",
  "v5.m1.publication.choisir_revision": "Choose a revision",
  "v5.m1.publication.contexte": "Application {{application}}, revision {{revision}}",
  "v5.m1.publication.lien": "Publication of revision {{revision}}",
  "v5.m1.publication.liste": "Application publications",
  "v5.m1.publication.onglet.branches": "Branches and merges",
  "v5.m1.publication.onglet.pipelines": "Repository pipelines",
  "v5.m1.publication.onglet.publications": "Publications",
  "v5.m1.publication.onglets": "Publishing sections",
  "v5.m1.publication.publier_revision": "Publish this revision",
  "v5.m1.publication.revision": "Revision",
  "v5.m1.publication.revision_a_choisir": "Choose a revision to publish it.",
  "v5.m1.publication.statut.failed": "Failed",
  "v5.m1.publication.statut.published": "Published",
  "v5.m1.publication.statut.publishing": "Publishing",
  "v5.m1.publication.statut.requested": "Requested",
  "v5.m1.publication.titre": "Code publishing",
  "v5.m1.publication.vide": "No publication for this application.",
  "v5.m1.publier.application": "Application",
  "v5.m1.publier.autorisee": "Publishing allowed.",
  "v5.m1.publier.bloquee": "Publishing blocked: the repository is not ready.",
  "v5.m1.publier.confirmer": "I confirm publishing this exact revision to the application repository.",
  "v5.m1.publier.contexte_requis": "Open this dialog from an application revision.",
  "v5.m1.publier.controles": "Checks",
  "v5.m1.publier.controles_valeur": "{{passes}} / {{total}} passed",
  "v5.m1.publier.demandee": "Publication requested.",
  "v5.m1.publier.echec": "Publishing failed.",
  "v5.m1.publier.effet_destination": "Destination: the repository of application {{application}}.",
  "v5.m1.publier.effet_immuable": "The published revision is exact and never changes.",
  "v5.m1.publier.effet_port": "A linked environment may expose this revision on its port.",
  "v5.m1.publier.preconditions": "Repository preconditions",
  "v5.m1.publier.publier": "Publish",
  "v5.m1.publier.raison_bloquee": "Publishing is impossible until the repository is ready.",
  "v5.m1.publier.raison_confirmer": "Confirm the publication to continue.",
  "v5.m1.publier.relecture": "Review",
  "v5.m1.publier.relecture_serveur": "Third-party review checked by the gateway on publishing",
  "v5.m1.publier.revision": "Revision",
  "v5.m1.publier.revision_inconnue": "This revision was not found in the application.",
  "v5.m1.publier.source": "Source revision",
  "v5.m1.publier.titre": "Publish a code revision",
  "v5.m1.publier.verdict.approve": "Reviewed and approved",
  "v5.m1.publier.verdict.reject": "Rejected in review",
  "v5.m1.retour.aucune_generation": "No finished generation in this project.",
  "v5.m1.retour.choisir_generation": "Choose a generation",
  "v5.m1.retour.choisir_note": "Choose a rating",
  "v5.m1.retour.commentaire": "Comment (optional)",
  "v5.m1.retour.echec": "The feedback was not sent.",
  "v5.m1.retour.envoye": "Feedback sent.",
  "v5.m1.retour.envoyer": "Send the feedback",
  "v5.m1.retour.evaluation": "Used by the evaluation of {{sujet}} ({{score}} %)",
  "v5.m1.retour.generation": "Generation",
  "v5.m1.retour.generation_requise": "Choose the generation you comment on.",
  "v5.m1.retour.generation_source": "Source generation: {{id}}",
  "v5.m1.retour.generations": "Project generations",
  "v5.m1.retour.libelle": "Feedback",
  "v5.m1.retour.note": "Rating",
  "v5.m1.retour.note_option": "{{note}} out of 5",
  "v5.m1.retour.note_requise": "Give a rating between 1 and 5.",
  "v5.m1.retour.note_valeur": "Rating: {{note}} / 5",
  "v5.m1.retour.numero": "Feedback #{{id}}",
  "v5.m1.retour.par": "By {{auteur}}",
  "v5.m1.retour.sans_commentaire": "No comment.",
  "v5.m1.retour.sans_generation": "Source generation not identified.",
  "v5.m1.retour.titre_editeur": "Give feedback on a generation",
  "v5.m1.retour.titre_fiche": "Recorded generation feedback",
  "v5.m1.retour.voir_generation": "View the generation",
  "v5.m1.retour_publication": "Back to code publishing",
  "v5.m1.sans_projet": "Choose a project to open this screen.",
  "v5.m1.valider.attestation": "I confirm I reviewed this executable test.",
  "v5.m1.valider.attestation_requise": "Tick the review confirmation to validate.",
  "v5.m1.valider.auteur": "Test author: {{auteur}}",
  "v5.m1.valider.deja_valide": "Already validated by {{validateur}}",
  "v5.m1.valider.echec": "Validation failed.",
  "v5.m1.valider.empreinte": "Code fingerprint: {{empreinte}}",
  "v5.m1.valider.observation": "Comment (optional)",
  "v5.m1.valider.sans_test": "This case has no executable test to validate.",
  "v5.m1.valider.titre": "Validate an executable test",
  "v5.m1.valider.valide": "Test validated.",
  "v5.m1.valider.valider": "Validate the test"
}
